export default {"src":"/_next/static/media/gridFilled.a570bd78.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};